import { useState } from "react";
import "../clients/ClientTable.css";
export default function UsersTable({users, onEdit, onDelete }) {
   const [search, setSearch] = useState("");
   const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // nombre par page

   // 🔍 Filtrage
  // const filteredClients = clients.filter(client =>
  //   client.nom?.toLowerCase().includes(search.toLowerCase()) ||
  //   client.email?.toLowerCase().includes(search.toLowerCase())
  // );
  const filteredUser =(users || []).filter(t => {
  const q = (search || "").toLowerCase();
  return (
    (t?.nom || "").toLowerCase().includes(q) ||
    (t?.email || "").toLowerCase().includes(q)
  );
});

const totalPages = Math.ceil(filteredUser.length / itemsPerPage);

const startIndex = (currentPage - 1) * itemsPerPage;
const endIndex = startIndex + itemsPerPage;

const paginatedUsers = filteredUser.slice(startIndex, endIndex);
  return (
  <div className="table-container">

      {/* Champ recherche */}
      <input
        type="text"
        placeholder="Rechercher par nom ou role..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{ padding: "8px", width: "100%", marginBottom: "15px" }}
      />
      {filteredUser.length === 0 ? (
        <p>Aucun Admin trouvé</p>
      ) : ( <table className="responsive-table">
      <thead>
        <tr>
          <th>Nom</th>
          <th>Email</th> 
          <th>Role</th>         
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {paginatedUsers.map((c) => (
       
          <tr key={c.id}>
            <td data-label="Nom et prénom">{c.nom}</td>
            <td data-label="Email">{c.email}</td>
             <td data-label="Role">{c.role}</td>
            
            
            <td data-label="Actions">
              <button className="btn edit" onClick={() => onEdit(c)}>✏️</button>
              <button className="btn delete" onClick={() => onDelete(c.id)}>🗑</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
   )}

   <div className="pagination">
  <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage(currentPage - 1)}
  >
    ◀
  </button>

  {Array.from({ length: totalPages }, (_, i) => (
    <button
      key={i}
      className={currentPage === i + 1 ? "active" : ""}
      onClick={() => setCurrentPage(i + 1)}
    >
      {i + 1}
    </button>
  ))}

  <button
    disabled={currentPage === totalPages}
    onClick={() => setCurrentPage(currentPage + 1)}
  >
    ▶
  </button>
</div>

  </div>
  

  );
}
